import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { ItemPedido } from '../models/pedido';
import { Filtro } from '../models/filtro';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { ProdutoService } from '../services/produto.service';
import { UtilitarioService } from '../services/utilitario.service';
import { GlobalService } from '../services/global.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { Produto } from '../models/produto';
import swal from 'sweetalert2';
import { AutenticacaoService } from '../services/autenticacao.service';
import { DetalheProdutoModalComponent } from '../modals/detalhe-produto-modal/detalhe-produto-modal.component';
import { ProdutosSelecionadosModalComponent } from '../modals/produtos-selecionados-modal/produtos-selecionados-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Marca } from '../models/marca';
import { MarcaService } from '../services/marca.service';
import { PremissasService } from '../services/premissas.service';
import { LotesDoProdutoModalComponent } from '../modals/lotes-do-produto-modal/lotes-do-produto-modal.component';
import { PaginatorService } from '../services/paginator.service';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { PrecificacaoUFService } from '../services/precificacao-uf.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { Cliente } from '../models/cliente';
import { TipoFiltroProduto } from "../models/enum";
import { Categoria } from "../models/categoria";
import { CategoriaService } from "../services/categoria.service";

// jquery
declare const $: any;

@Component({
  selector: 'app-produto',
  templateUrl: './produto.component.html',
  styleUrls: ['./produto.component.scss']
})
export class ProdutoComponent implements OnInit, OnDestroy {
  private alterouAbaSubscription: Subscription;

  @Input() alterouAba: Observable<number>;
  @Input() tipo: string;
  @Input() itensSelecionados: ItemPedido[];
  @Input() franquia: string;
  @Input() potencia: number;
  @Input() origem: number;
  @Input() idFornecedorPainel: number;
  @Input() selecionaSomenteUm: boolean;
  @Input() situacao: string;
  @Input() naoMostrarValores: boolean;
  @Input() descAcresPrecificacaoUF: PrecificacaoUF;
  @Input() somenteMSK: boolean;
  @Input() versaoModal: number = 1;
  @Input() idLoja: number;
  @Input() cliente: Cliente;
  @Output() alterou = new EventEmitter();

  filtrarPotencia = false;
  kitFechado = false;
  visivel = false;

  vendaProgramada = false;

  buscou = false;
  itensFiltrados: ItemPedido[] = [];
  verCustos = undefined;
  carregando = true;
  campoOrdenacao = 'checado';
  ordenarDesc = false;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroDescricao: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroDescricao];
  integrador = false;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  premissasSistema = new PremissasSistema();

  referencia;

  buscarTodosProdutos = true;

  marcaSelecionada: number;
  marcas: Marca[];
  mostrarValores = false;
  usarPrecoAvulso: false;

  categorias: Categoria[] = [];
  categoriaSelecionada: number = null;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialog: MatDialog,
    private produtoService: ProdutoService,
    public utilitarioService: UtilitarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private marcaService: MarcaService,
    private premissasService: PremissasService,
    private paginatorService: PaginatorService,
    private precificacaoUFService: PrecificacaoUFService,
    private categoriaService: CategoriaService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itensSelecionados) {
      this.itensSelecionados = changes.itensSelecionados.currentValue;

      if (!this.itensSelecionados || this.itensSelecionados === null || this.itensSelecionados.length === 0) {
        this.itensFiltrados.forEach(p => { p.checado = false; p.qt = undefined; });
      }
    }
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    await this.buscarVendaProgramada();
    await this.buscarPremissasSistema();

    if (this.versaoModal === 1) {
      await this.buscarCategoriasFiltro(this.tipo);
    }

    this.integrador = await this.globalService.integrador();
    this.carregandoService.mostra('buscarUsarPrecoAvulso');
    this.premissasService.consultarUsarPrecoAvulso().subscribe(async f => {
      this.usarPrecoAvulso = f.valor;
      this.buscarVerPrecosProdutos();
      this.listarMarcas();

      const equals = (a, b) =>
        a.length === b.length &&
        a.every((v, i) => v === b[i]);

      this.verCustos = (await this.globalService.consultaUsuario()).verCustos;

      this.alterouAbaSubscription = this.alterouAba.subscribe((dados: any) => {
        this.visivel = (this.versaoModal === 1 ? dados.familia : dados.categoria) === Number(this.tipo);

        if ((this.versaoModal === 1 ? dados.familia : dados.categoria) === Number(this.tipo) && (this.buscou === false ||
          (Number(this.tipo) !== 2 && Number(this.tipo) !== 7 &&
            (this.itensFiltrados.length > 0 || this.filtroDescricao.Valor)))) {

          this.buscou = true;
          if (this.buscarTodosProdutos || ((this.itensFiltrados.length > 0 || this.filtroDescricao.Valor))) {
            this.buscarProdutos();
          }
        }
      });
      this.carregandoService.esconde('buscarUsarPrecoAvulso');
    }, (erro) => {
      this.carregandoService.esconde('buscarUsarPrecoAvulso');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarCategoriasFiltro(familia) {
    this.carregandoService.mostra('buscarCategoriasFiltro');
    this.categoriaService.buscarCategoriasPorFamilia(familia).subscribe(data => {
      this.categorias = data;
      this.carregandoService.esconde('buscarCategoriasFiltro');
    }, (erro) => {
      this.carregandoService.esconde('buscarCategoriasFiltro');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarVendaProgramada() {
    try {
      this.carregandoService.mostra('buscarVendaProgramada');
      this.vendaProgramada = (await this.premissasService.consultarVendaProgramada().toPromise()).valor;
      this.carregandoService.esconde('buscarVendaProgramada');
    } catch (erro) {
      this.carregandoService.esconde('buscarVendaProgramada');
      this.notificacaoService.erro(erro);
    }
  }


  buscarProdutos() {
    this.carregandoService.mostra('buscaProduto' + this.tipo);
    this.carregando = true;

    this.produtoService.consultarComPaginacao(
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
      this.filtroDescricao.Valor, '',
      this.situacao,
      this.versaoModal === 2 ? null : Number(this.tipo),
      true,
      this.potencia === 0 ? null : this.potencia,
      this.marcaSelecionada,
      null, null, null,
      this.idFornecedorPainel,
      null, null, null, null, null, null,
      this.origem === 2,
      null, null, true, null, null, null, null, this.referencia,
      'A',
      null,
      this.versaoModal === 2 ? Number(this.tipo) : this.categoriaSelecionada,
      this.origem,
      this.idLoja
    ).subscribe(dados => {
      const produtos: Produto[] = dados.itens;
      this.itensFiltrados = [];

      produtos.forEach(p => {
        const novoItem = new ItemPedido();
        if ((this.origem === 2 && this.usarPrecoAvulso) || this.origem === 3) {
          novoItem.pUnitario = p.precoAvulso;
        }
        else {
          novoItem.pUnitario = p.precoVenda;
        }
        novoItem.pCusto = p.precoCusto;
        novoItem.produto = p.idProduto;
        novoItem.produtoTela = p;
        novoItem.det1 = p.descricaoAtual;


        novoItem.pVendaOriginal = p.precoVenda;

        const podeAdicionar = !this.somenteMSK || p.aparecerMSK;
        if (podeAdicionar) {
          this.itensFiltrados.push(novoItem);
        } else {
          dados.total--;
        }

      });

      this.atualizaProdutos();

      this.paginacao.total = dados.total;
      this.carregando = false;
      this.carregandoService.esconde('buscaProduto' + this.tipo);

    }, (erro) => {
      this.carregandoService.esconde('buscaProduto' + this.tipo);
    });
  }

  selecionarProdutos() { }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;
      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarProdutos();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) {
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);
    }

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  excluir(item: ItemPedido) {
    this.itensSelecionados.splice(this.itensSelecionados.indexOf(item), 1);
    item.checado = false;
    item.qt = undefined;
  }

  adicionarRemoverProduto(item: ItemPedido) {
    if (!item.checado && (Number(this.tipo) === 2) && this.itensSelecionados.length === 1 && this.origem !== 2 && this.origem !== 3 && this.integrador) {
      item.checado = false;
      swal({
        title: 'Atenção!!',
        text: 'Já existe um Painel selecionado!!',
        type: 'warning',
        showCancelButton: false,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then(() => {
        item.checado = false;
        return;
      });

    } else {
      item.checado = !item.checado;

      if (item.checado) {
        if (!item.qt || Number(item.qt) <= 0) {
          item.qt = 1;
        }

        this.validaQtd(item);

        this.itensSelecionados.push(item);
      } else {
        this.excluir(item);
      }

      this.alterou.emit(this.itensSelecionados);
    }
  }

  validaQtd(item: ItemPedido) {


    if (this.origem === 3) {
      if (this.itensSelecionados.some(p => p.produto === item.produto) && (item.qt === null ||
        item.qt === undefined || Number.isNaN(Number(item.qt)) || Number(item.qt) < 0)) {
        item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
        this.alteraQuantidade(item);
      } else if (Number(item.qt) > 100000) {
        item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ?
          this.utilitarioService.multiploOuMaisProximo(Number(item.qt), item.produtoTela.valorMultiplo, item.produtoTela.valorMultiplo, 100000, 'down') : 100000;
        this.alteraQuantidade(item);
      } else if (item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0) {
        item.qt = this.utilitarioService.multiploOuMaisProximo(Number(item.qt), item.produtoTela.valorMultiplo, item.produtoTela.valorMultiplo, 100000, 'up');
        this.alteraQuantidade(item);
      }
    } else {
      if (this.itensSelecionados.some(p => p.produto === item.produto) && (item.qt === null ||
        item.qt === undefined || Number.isNaN(Number(item.qt)) || Number(item.qt) < 0)) {
        item.qt = 1;
        this.alteraQuantidade(item);
      } else if (Number(item.qt) > 100000) {
        item.qt = 100000;
        this.alteraQuantidade(item);
      }
    }
  }

  alteraQuantidade(item: ItemPedido) {

    if (this.itensSelecionados.some(p => p.produto === item.produto)) {
      this.itensSelecionados.find(p => p.produto === item.produto).qt = item.qt;
    }

    this.alterou.emit(this.itensSelecionados);
  }

  atualizaProdutos() {
    this.itensFiltrados.filter(p => this.itensSelecionados.some(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto)).forEach(p => {
      p.checado = true;
      p.qt = this.itensSelecionados.find(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt;
    });
  }

  ngOnDestroy() {
    this.alterouAbaSubscription.unsubscribe();
  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        produto: produto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  mostrarProdutosSelecionados() {

    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(ProdutosSelecionadosModalComponent, {
      // passa os produtos já selecionados
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        itensSelecionados: this.itensSelecionados
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result && result.length > 0) {
        result.forEach(r => {
          this.excluir(r);
        });

        this.alterou.emit(this.itensSelecionados);
        this.buscarProdutos();
      }
    }
    );
  }

  calculaAltura() {
    return $('#' + this.tipo + 'tamanho-tabela-produto').parent().height() - 100; // document.getElementsByClassName('tamanho-tabela-produto')[0].parentElement.clientHeight - 100;
  }

  listarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.listarPorFamilia(Number(this.tipo)).subscribe(
      (marcs) => {
        this.marcas = marcs;
        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  mostrarLotesDoProduto(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(LotesDoProdutoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { idProduto: produto.idProduto, idFornecedor: this.idFornecedorPainel },
      panelClass: 'modal-card',
    });
  }

  calcularPrecificacao(precoUnitario: number) {

    const precoBase = precoUnitario;

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoUF(precoBase, this.descAcresPrecificacaoUF);
    }

    if (this.premissasSistema.habilitarPrecificacaoPorIntegrador && this.cliente && this.origem === 3) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoIntegrador(precoUnitario, precoBase, this.cliente.tipoPrecificacao, this.cliente.valorPrecificacao);
    }

    return precoUnitario;
  }
}
